export default __webpack_public_path__ + "static/media/puppeteer.3b3c0d0a.svg";